import courseSyncService from '../../services/courseSyncService';
import CourseImportSync from './CourseImportSync';

export default function DoceboCourseImport() {
  return <CourseImportSync syncAction={courseSyncService.syncDocebo} loadingMessage="Syncing courses from Docebo… this may take a minute." />;
}
